import React, { FC } from 'react'
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface SerialNumberHistoryItemHeaderProps {
    component: string;
    newProduct?: string;
    oldProduct?: string;
}

export const SerialNumberHistoryItemHeader: FC<SerialNumberHistoryItemHeaderProps> = ({ component, newProduct, oldProduct }) => {
    const { t } = useTranslation();

    if (!newProduct && !oldProduct) {
        return <></>
    } else if (newProduct && oldProduct) {
        return (
            <Typography>
                {t('history.update', { removed: oldProduct, added: newProduct, component: component })}
            </Typography>
        )
    }
    
    return newProduct ? (
        <Typography>
            {t('history.add', { product: newProduct, component: component })}
        </Typography>
    ) : (
        <Typography>
            {t('history.remove', { product: oldProduct, component: component })}
        </Typography>
    )
}
